const JOBBER_DEFAULT_BASE_URL = 'https://secure.getjobber.com'
const JOBBER_DEFAULT_JOB_PATH = 'work_orders'

type MaybeString = string | number | null | undefined

export interface JobLinkSource {
  jobberWebUri?: MaybeString
  jobNumber?: MaybeString
  jobId?: MaybeString
}

export interface JobLinkOptions {
  baseUrl?: string
  fallbackPath?: string
}

const trimValue = (value?: MaybeString): string | null => {
  if (value === null || value === undefined) return null
  const trimmed = String(value).trim()
  return trimmed.length ? trimmed : null
}

const sanitizeUrl = (value?: MaybeString): string | null => {
  const raw = trimValue(value)
  if (!raw) return null

  try {
    const hasProtocol = /^https?:\/\//i.test(raw)
    const url = new URL(hasProtocol ? raw : `https://${raw}`)
    return url.toString()
  } catch {
    return null
  }
}

const buildBaseUrl = (baseUrl?: string): string => {
  const base = baseUrl?.trim() || JOBBER_DEFAULT_BASE_URL
  return base.endsWith('/') ? base.slice(0, -1) : base
}

const buildPath = (path?: string): string => {
  const normalizedPath = path?.trim() || JOBBER_DEFAULT_JOB_PATH
  return normalizedPath.replace(/^\/+/, '')
}

export const buildJobberJobUrl = (
  source: JobLinkSource,
  options: JobLinkOptions = {}
): string | null => {
  const directUrl = sanitizeUrl(source.jobberWebUri)
  if (directUrl) return directUrl

  const jobNumber = trimValue(source.jobNumber) ?? trimValue(source.jobId)
  if (!jobNumber) return null

  const baseUrl = buildBaseUrl(options.baseUrl)
  const path = buildPath(options.fallbackPath)

  return `${baseUrl}/${path}/${jobNumber}`
}

export const extractJobNumberFromJobberUri = (uri?: MaybeString): number | null => {
  const sanitized = sanitizeUrl(uri)
  if (!sanitized) return null

  try {
    const url = new URL(sanitized)
    const match = url.pathname.match(/(\d+)(?:\/)?$/)
    if (!match) return null
    const parsed = Number(match[1])
    return Number.isNaN(parsed) ? null : parsed
  } catch {
    return null
  }
}
